module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Bold-Italic.04620d91.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Bold-Italic.otf
// module id = 3583
// module chunks = 68